import { defineMessages } from 'react-intl'

const scope = `procurify.discover-more.page`

export default defineMessages({
  discoverMorePageTitle: {
    id: `${scope}.discoverMorePageTitle`,
    defaultMessage: 'Discover more',
  },
})
